import KanbanAutoColumns from './KanbanAutoColumns'

export default KanbanAutoColumns
